module.exports = __webpack_public_path__ + "static/media/Quantifi.a541fc82.svg";